import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  swiper: 'data-history-swiper',
  json: 'type="application/json"',
}
const qsAll = {
  sections: 'data-section-type="history"',
  buttons: 'data-history-btn',
  // images: 'data-history-image',
}
Array.prototype.max = function () {
  return Math.max.apply(null, this)
}
const updateHeights = (section) => {
  const heights = []
  section.querySelectorAll('.swiper-slide').forEach((slide) => {
    slide.style.height = ''
    heights.push(slide.offsetHeight)
  })
  const maxHeight = heights.max()
  section.querySelectorAll('.swiper-slide').forEach((slide) => (slide.style.height = `${maxHeight}px`))
}
const initSection = (section) => {
  const sectionSwiper = new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: 1,
    spaceBetween: 245,
    slideToClickedSlide: true,
    breakpoints: {
      320: {
        spaceBetween: 12,
      },
      768: {},
      1024: {
        spaceBetween: 24,
      },
      1100: {
        spaceBetween: 100,
      },
      1300: {
        spaceBetween: 180,
      },
      1440: {
        spaceBetween: 245,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<button class="${className} text-white !w-auto !h-auto !rounded-none !bg-transparent !m-0 text-sm leading-4 focus-visible:outline">${JSON.parse(section.querySelector(`[${qs.json}]`).innerHTML)[index]}</button>`
      },
    },
    on: {
      init: function () {
        updateHeights(section)
      },
      resize: function () {
        updateHeights(section)
      },
    },
  })
  section.querySelectorAll(`[${qsAll.buttons}]`).forEach((button) => {
    button.addEventListener('click', (e) => {
      const btnIndex =
        e.target.className == 'BUTTON' ? e.target.dataset.historyBtn : e.target.closest('button').dataset.historyBtn
      sectionSwiper.slideTo(parseInt(btnIndex))
    })
  })
}

export const setupHistory = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    initSection(section)
  })
}
